const STATUS_MAP: Record<string, { cls: string; label: string }> = {
  delivered:   { cls: 'badge-green',  label: 'Livré' },
  in_transit:  { cls: 'badge-blue',   label: 'En route' },
  picked_up:   { cls: 'badge-amber',  label: 'Récupéré' },
  pending:     { cls: 'badge-navy',   label: 'En attente' },
  matching:    { cls: 'badge-navy',   label: 'Matching' },
  accepted:    { cls: 'badge-blue',   label: 'Accepté' },
  validated:   { cls: 'badge-blue',   label: 'Validé' },
  assigned:    { cls: 'badge-purple', label: 'Assigné' },
  cancelled:   { cls: 'badge-rose',   label: 'Annulé' },
  failed:      { cls: 'badge-rose',   label: 'Échoué' },
  unreachable: { cls: 'badge-rose',   label: 'Injoignable' },
  returned:    { cls: 'badge-amber',  label: 'Retourné' },
  scheduled:   { cls: 'badge-purple', label: 'Planifié' },
  paid:        { cls: 'badge-green',  label: 'Payé' },
  unpaid:      { cls: 'badge-amber',  label: 'Impayé' },
  refunded:    { cls: 'badge-rose',   label: 'Remboursé' },
  active:      { cls: 'badge-green',  label: 'Actif' },
  suspended:   { cls: 'badge-rose',   label: 'Suspendu' },
}

interface StatusBadgeProps {
  status: string
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const b = STATUS_MAP[status] ?? { cls: 'badge-navy', label: status }
  return (
    <span className={`badge ${b.cls}`}>
      <span className="badge-dot-tiny" />
      {b.label}
    </span>
  )
}
